import { ReactElement } from 'react';
import { MarketplaceSquareLogo } from 'src/components/common/MarketplaceSquareLogo';
import { useContent } from 'src/contexts/ContentContext';
import { Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { MarketplaceSalePayment } from 'src/WebApiController';

import * as styles from './Payments.css';

const PaymentRow = ({
  title,
  children,
}: {
  title: string;
  children: ReactElement;
}) => {
  return (
    <Stack direction="column" alignItems="center" className={styles.tabWrapper}>
      <div className={styles.paymentsSearchResultTitle}>{title}</div>
      <div className={styles.paymentsSearchResultValue}>{children}</div>
    </Stack>
  );
};

export const PaymentBasicDisplay = ({
  marketplaceSalePaymentData,
}: {
  marketplaceSalePaymentData: MarketplaceSalePayment;
}) => {
  const paymentIdTitle = useContent(ContentId.Id);
  const paymentDatesTitle = useContent(ContentId.PaymentDate);
  const marketplaceTitle = useContent(ContentId.Marketplace);
  const externalPaymentRefTitle = useContent(ContentId.PaymentId);
  const paymentAmountTitle = useContent(ContentId.PaymentAmount);
  const creditTitle = useContent(ContentId.Credit);
  const chargeTitle = useContent(ContentId.Charge);
  const stateTitle = useContent(ContentId.State);

  const { id, pmtDate, mkp, extPmtId, pmtAmt, credit, charge, state } =
    marketplaceSalePaymentData;
  return (
    <Stack
      style={{ width: '100%' }}
      justifyContent="spaceBetween"
      flexWrap="wrap"
      gap={'l'}
    >
      <PaymentRow title={externalPaymentRefTitle}>
        <span>{extPmtId}</span>
      </PaymentRow>
      <PaymentRow title={paymentIdTitle}>
        <span>{id}</span>
      </PaymentRow>
      {pmtDate && (
        <PaymentRow title={paymentDatesTitle}>
          <span>{new Date(pmtDate).toLocaleDateString()}</span>
        </PaymentRow>
      )}
      <PaymentRow title={marketplaceTitle}>
        <MarketplaceSquareLogo marketplace={mkp} />
      </PaymentRow>
      <PaymentRow title={paymentAmountTitle}>
        <span>{pmtAmt.amt}</span>
      </PaymentRow>
      <PaymentRow title={creditTitle}>
        <span>{credit?.amt}</span>
      </PaymentRow>
      <PaymentRow title={chargeTitle}>
        <span>{charge?.amt}</span>
      </PaymentRow>
      <PaymentRow title={stateTitle}>
        <span>{state}</span>
      </PaymentRow>
    </Stack>
  );
};
